module.exports = __webpack_public_path__ + "img/cmg-labs-3.49c949e8.webp";